import { useTourStore } from '../stores/tourStore';
import { TourRegistry } from '../tours/TourRegistry';
import type { TourKey, TourDefinition } from '../types/tour';

export function useTour() {
  const activeTourKey = useTourStore((s) => s.activeTourKey);
  const startTour = useTourStore((s) => s.startTour);
  const forceStartTour = useTourStore((s) => s.forceStartTour);
  const completeTour = useTourStore((s) => s.completeTour);
  const skipTour = useTourStore((s) => s.skipTour);
  const isVisited = useTourStore((s) => s.isVisited);

  const activeTour: TourDefinition | null = activeTourKey
    ? TourRegistry[activeTourKey] ?? null
    : null;

  const markVisited = (key: TourKey) => {
    completeTour(key);
  };

  return {
    activeTour,
    startTour,
    forceStartTour,
    markVisited,
    skipTour,
    isVisited,
  };
}
